export default {
  menu: {
    analytics: 'Analytics',
    prototype: 'Prototype Features',
    candidateSearch: 'Candidate Lookup',
    managementOverview: 'Management Overview',
  },
  tooltip: {
    dashboard: 'To Do List',
    jobs: 'Positions',
    calendar: 'Calendar',
    messaging: 'Messaging',
    menu: 'Menu',
    notification: 'Notifications',
  },
};
